import App from '@/App.vue'
import { storeRegistryPlugin } from '@/pinia/storeRegistry'
import { plugins as pluginsts } from '@/plugins-ts'
import router from '@/router'
import { SetDefaultLanguage, i18n } from '@/utils-ts'
import * as Sentry from '@sentry/vue'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { createPinia } from 'pinia'
import CodeDiff from 'v-code-diff'
import { createApp } from 'vue'
//import { InitClarity } from './plugins-ts/Clarity'

ModuleRegistry.registerModules([AllCommunityModule])

export const pinia = createPinia()
pinia.use(storeRegistryPlugin)

const APP_VERSION = '__BUILD_VERSION__' // Vite build sırasında değiştirilecek

function checkAndClearCache() {
  const storedVersion = localStorage.getItem('app_version')

  if (storedVersion !== APP_VERSION) {
    console.log('Yeni versiyon tespit edildi, cache temizleniyor...')

    // LocalStorage'daki versiyon bilgisini güncelle
    localStorage.setItem('app_version', APP_VERSION)

    // Service Worker varsa temizle
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => registration.unregister())
      })
    }

    // Cache API'yi temizle
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name))
      })
    }

    // Sayfayı hard reload yap (cache'siz yeniden yükle)
    window.location.reload()
    return true
  }

  return false
}

// Yeni deploy sonrası açık kalan sekme, artık sunucuda olmayan eski hash'li chunk'ları ister.
// Sayfayı yenileyip yeni build'i yükle; chunk gerçekten bozuksa sonsuz döngüye girmemek için
// kısa süre içinde ikinci kez yenileme yapma.
window.addEventListener('vite:preloadError', event => {
  const key = 'preload_error_reload_at'
  const lastReload = Number(sessionStorage.getItem(key) || 0)
  if (Date.now() - lastReload < 10_000) return
  event.preventDefault()
  sessionStorage.setItem(key, String(Date.now()))
  window.location.reload()
})

if (!checkAndClearCache()) {
  SetDefaultLanguage()

  const app = createApp(App)

  if (import.meta.env.PROD) {
    console.log('Sentry enabled')
    Sentry.init({
      app,
      dsn: 'https://189462299b9a505da2570e890fb535cc@o120060.ingest.us.sentry.io/4507843562307584',
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 1.0,
    })
  }

  //InitClarity()

  app.use(i18n)
  app.use(pluginsts)
  app.use(pinia)
  app.use(CodeDiff)
  app.use(router)
  app.mount('#app')
}
